@import (reference) '../../../../../constants/spacing.module.less';
@import '~style-sheet-helpers/core.less';

.currency-field-label {
  color: var(--default--text-color--17);
  font-size: 12px;
  line-height: 15px;
  margin-bottom: @space-4;
}

.currency-field-container {
  display: flex;

  > button {
    margin-left: @space-4;
  }
}

.currency-field-content {
  color: var(--default--text-color--15);
  font-size: 14px;
  line-height: 18px;
}

.discount-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: @space-16;
  font-size: 14px;

  th,
  td {
    text-align: left;
    vertical-align: top;
    padding: @space-16;
  }

  th {
    background-color: var(--default--background-color--14);
    font-weight: 500;
    line-height: 18px;
  }

  tr {
    border-bottom: 1px solid var(--table--border-color--2);
  }

  tr:last-child {
    border-bottom: none;
  }
}
